import styled from 'styled-components';

export const ForgotPasswordLinkWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  text-align: left;
  flex-wrap: wrap;
`;

// The link label carries the provider name and cannot wrap, so without this the
// question is the only thing that can shrink and it breaks mid-phrase.
export const Description = styled.p`
  flex-shrink: 0;
`;
